<template>
  <div class="section py-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h2 class="title is-4">
            {{ meOrg.name }}
          </h2>
        </div>
        <div class="column is-narrow is-flex">
          <!-- <iconRow
            :data="orgProduct(meOrg.id)"
            dataClass="mr-2"
            dataSize="is-medium"
          /> -->
          <orgTag
            :data="meOrg.license_type"
            :test="meOrg.test"
            dataSize="is-medium"
          />
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns is-desktop">
        <div class="column is-half-desktop">
          <OrgSimple @submit="orgUpdate" :org="meOrg" />
        </div>
        <div class="column is-half-desktop">
          <div class="box">
            <div class="block">
              <inputBox :space="false">
                <b-table :data="orgUser(meOrg.id)" :mobile-cards="false">
                  <b-table-column
                    field="first_name"
                    label="Vorname"
                    v-slot="props"
                  >
                    {{ user(props.row).first_name }}
                  </b-table-column>

                  <b-table-column
                    field="last_name"
                    label="Nachname"
                    v-slot="props"
                  >
                    {{ user(props.row).last_name }}
                  </b-table-column>

                  <b-table-column field="email" label="E-Mail" v-slot="props">
                    {{ user(props.row).email }}
                  </b-table-column>

                  <b-table-column field="type" v-slot="props">
                    <userTag :data="user(props.row).type" dataSize="is-small" />
                  </b-table-column>

                  <b-table-column field="type" v-slot="props">
                    <template v-if="props.row === meUser.id">
                      <router-link
                        :to="{
                          name: 'UserProfile',
                        }"
                      >
                        <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
                      </router-link>
                    </template>
                    <template v-else-if="user(props.row).type !== 'admin'">
                      <router-link
                        :to="{
                          name: 'UserProfileId',
                          params: { userId: props.row },
                        }"
                      >
                        <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
                      </router-link>
                    </template>
                  </b-table-column>
                </b-table>
              </inputBox>
            </div>
            <div class="columns">
              <div class="column is-narrow is-flex is-align-items-center">
                <div class="content">
                  Accounts:
                  {{ orgUser(meOrg.id).length
                  }}{{
                    meOrg.user_amount !== null ? `/${meOrg.user_amount}` : null
                  }}
                </div>
              </div>
              <div class="column is-narrow">
                <b-button
                  :disabled="
                    !(
                      meOrg.user_amount > orgUser(meOrg.id).length ||
                      meOrg.user_amount === null
                    )
                  "
                  type="is-outlined is-gold"
                  icon-left="plus"
                  icon-pack="fas"
                  tag="router-link"
                  :to="{ name: 'NewUserOrg' }"
                >
                  Neuer Nutzer
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// import iconRow from '@/components/helper/IconRow.vue';
import userTag from '@/components/editUser/UserTag.vue';
import orgTag from '@/components/editOrg/OrgTag.vue';
import OrgSimple from '@/components/editOrg/OrgSimple.vue';

import inputBox from '@/components/helper/InputBox.vue';

export default {
  name: 'ViewOrg',
  // metaInfo: {
  //   title: 'Organization',
  // },
  components: {
    // iconRow,
    inputBox,
    orgTag,
    userTag,
    OrgSimple,
  },
  data() {
    return {
      active: 0,
    };
  },
  props: ['userId'],
  computed: {
    ...mapGetters({
      meUser: 'user/me',
      user: 'user/dataById',
      errorUser: 'user/error',
      meOrg: 'org/me',
      errorOrg: 'org/error',
      orgProduct: 'org/product/dataByParentId',
      orgUser: 'org/user/dataByParentId',
    }),
  },
  methods: {
    orgUpdate(org) {
      this.$store.dispatch('org/UPDATE', {
        id: org.id,
        street: org.street,
        house_no: org.house_no,
        street_additional: org.street_additional,
        zip_code: org.zip_code,
        city: org.city,
      });
    },
  },
};
</script>
